var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('StripeAccount',{staticClass:"mb-8",attrs:{"setup-mode":_vm.setupMode}}),_vm._v(" "),_c('div',{staticClass:"xl:flex"},[_c('BankAccountContainer',{staticClass:"mb-12 xl:w-1/2 xl:mr-4"}),_vm._v(" "),_c('MembershipFeeContainer',{staticClass:"xl:ml-4"})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }